module.exports = __webpack_public_path__ + "img/planting_04.9ca9db8.jpg";